import pdfMake from 'pdfmake/build/pdfmake';

import pdfFonts from 'pdfmake/build/vfs_fonts';

import {
  format,
  parse,
} from 'date-fns';

import logoReports from '../../../images/base64Images';

function Report3PDF(reportData) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const reportTitle = [
    {
      table: {
        widths: ['*', '*', '*', '*', '*', 150],
        body: [
          [
            {
              text: reportData.reportTitle,
              fontSize: 15,
              bold: true,
              alignment: 'center',
              margin: [140, 15, 0, 15],
              colSpan: 5,
              border: [true, true, false, true],
            },
            {},
            {},
            {},
            {},
            {
              width: 90,
              image: logoReports,
              border: [false, true, true, true],
              margin: [50, 10, 10, 10],
            },
          ],
        ],
      },
      layout: 'headerLineOnly',
    },
  ];

  const dataPart1 = reportData.casesToReceive.map((caseToReceive) => [
    {
      text: caseToReceive.client,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'left',
      border: [true, true, false, true],
    },
    {
      text: caseToReceive.origin,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: caseToReceive.partners ? caseToReceive.partners.join('\r\n') : '-',
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: caseToReceive.product,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: format(parse(caseToReceive.distributedAt.substring(0, 10), 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'),
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: (caseToReceive.caseNumber ? caseToReceive.caseNumber.replace(/\D/g, '').replace(/^(\d{7})(\d{2})?(\d{4})?(\d{1})?(\d{2})?(\d{4})?/, '$1-$2.$3.$4.$5.$6') : '-'),
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
  ]);

  const dataPart2 = reportData.casesReceived.map((caseReceived) => [
    {
      text: caseReceived.client,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'left',
      border: [true, true, false, true],
    },
    {
      text: caseReceived.origin,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: caseReceived.partners ? caseReceived.partners.join('\r\n') : '-',
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: caseReceived.product,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: format(parse(caseReceived.distributedAt.substring(0, 10), 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'),
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: (caseReceived.caseNumber ? caseReceived.caseNumber.replace(/\D/g, '').replace(/^(\d{7})(\d{2})?(\d{4})?(\d{1})?(\d{2})?(\d{4})?/, '$1-$2.$3.$4.$5.$6') : '-'),
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
    {
      text: caseReceived.paymentReceivedAt.length > 10 ? format(parse(caseReceived.paymentReceivedAt.substring(0, 10), 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy') : caseReceived.paymentReceivedAt,
      fontSize: 7,
      margin: [0, 5, 0, 2],
      alignment: 'center',
      border: [false, true, false, true],
    },
  ]);

  const header = [
    {
      table: {
        widths: [70, 120, 70, 120, '*', 70, 150],
        body: [
          [
            {
              text: 'Período:',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, true, false, false],
              fontSize: 8,
            },
            {
              text: (reportData.startDate && reportData.endDate) ? `${format(parse(reportData.startDate, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')} a ${format(parse(reportData.endDate, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}` : 'Geral',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, true, false, false],
              fontSize: 8,
            },
            {
              text: 'Origem:',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, true, false, false],
              fontSize: 8,
            },
            {
              text: reportData.origin ? reportData.origin : 'Geral',
              style: 'tableHeader',
              alignment: 'left',
              colSpan: 2,
              border: [false, true, false, false],
              fontSize: 8,
            },
            {},
            {
              text: 'Casos previstos:',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, true, false, false],
              fontSize: 8,
            },
            {
              text: reportData.casesToReceive.length,
              style: 'tableHeader',
              alignment: 'left',
              border: [false, true, false, false],
              fontSize: 8,
            },
          ],
          [
            {
              text: 'Produto:',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, false, false, true],
              fontSize: 8,
            },
            {
              text: reportData.product ? reportData.product : 'Geral',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, false, false, true],
              fontSize: 8,
            },
            {
              text: 'Parceiro:',
              style: 'tableHeader',
              alignment: 'left',
              border: [false, false, false, true],
              fontSize: 8,
            },
            {
              text: reportData.partner ? reportData.partner : 'Geral',
              style: 'tableHeader',
              alignment: 'left',
              colSpan: 2,
              border: [false, false, false, true],
              fontSize: 8,
            },
            {},
            {
              text: 'Casos recebidos:',
              style: 'tableHeader',
              lignment: 'left',
              border: [false, false, false, true],
              fontSize: 8,
            },
            {
              text: reportData.casesReceived.length,
              style: 'tableHeader',
              alignment: 'left',
              border: [false, false, false, true],
              fontSize: 8,
            },
          ],
        ],
      },
    },
  ];

  const details1 = [
    {
      table: {
        headerRows: 2,
        widths: ['*', 45, 45, '*', 75, 90],
        body: [
          [
            {
              text: 'CASOS DISTRIBUÍDOS COM RECEBIMENTOS PREVISTOS',
              style: 'tableHeader',
              colSpan: 6,
              alignment: 'left',
              margin: [0, 8, 0, 8],
            },
            {},
            {},
            {},
            {},
            {},
          ],
          [
            {
              text: 'CLIENTE',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'left',
              style: 'tableHeader',
              bold: true,
              border: [true, true, false, true],
            },
            {
              text: 'ORIGEM',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'PARCEIRO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'PRODUTO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'DATA DISTRIBUIÇÃO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'Nº PROCESSO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
          ],
          ...dataPart1,
        ],
      },
      layout: 'lightHorizontalLines',
    },
  ];

  const details2 = [
    {
      table: {
        headerRows: 2,
        widths: ['*', 45, 45, '*', 75, 90, 80],
        body: [
          [
            {
              text: 'CASOS RECEBIDOS',
              style: 'tableHeader',
              colSpan: 7,
              alignment: 'left',
              margin: [0, 8, 0, 8],
            },
            {},
            {},
            {},
            {},
            {},
            {},
          ],
          [
            {
              text: 'CLIENTE',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'left',
              style: 'tableHeader',
              bold: true,
              border: [true, true, false, true],
            },
            {
              text: 'ORIGEM',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'PARCEIRO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'PRODUTO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'DATA DISTRIBUIÇÃO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'Nº PROCESSO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
            {
              text: 'DATA RECEBIMENTO',
              margin: [0, 8, 0, 8],
              fontSize: 8,
              borderBotton: 2,
              alignment: 'center',
              style: 'tableHeader',
              bold: true,
              border: [false, true, false, true],
            },
          ],
          ...dataPart2,
        ],
      },
      layout: 'lightHorizontalLines',
    },
  ];

  function footer(currentPage, pageCount) {
    return {
      columns: [
        {
          text: `Gerado em: ${format(new Date(), 'dd/MM/yyyy HH:mm:ss')}`,
          fontSize: 7,
          margin: [20, 10, 0, 0], // left, top, right, bottom
        },
        {
          text: `${currentPage} / ${pageCount}`,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 20, 0], // left, top, right, bottom
        },
      ],
    };
  }

  const docDefinitions = {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [15, 40, 15, 40],
    content: [reportTitle, header, reportData.casesToReceive.length > 0 ? details1 : '', reportData.casesReceived.length > 0 ? details2 : ''],
    footer,
  };
  return docDefinitions;
}

export default Report3PDF;
